import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { Container } from "react-bootstrap";
import TextField from "@mui/material/TextField";
import ModalApp from "../../../../components/ModalApp";

export default function EmailModal({
  show,
  defaultEmail = "",
  onClose,
  onSave,
  isLoading = false,
}) {
  const [email, setEmail] = useState(defaultEmail);

  useEffect(() => {
    if (show) {
      setEmail(defaultEmail);
    }
  }, [defaultEmail, show]);

  function handleSave() {
    if (typeof onSave === "function") {
      onSave(email);
    }
  }

  return (
    <ModalApp show={show} handleModal={onClose}>
      <Container className="py-4 px-4">
        <h2
          style={{
            color: "var(--text-title)",
            fontWeight: 600,
            fontSize: "20px",
            marginBottom: "40px",
          }}
        >
          Cadastre um e-mail válido.
        </h2>

        <div className="mb-4">
          <label htmlFor="pf-email-input" className="visually-hidden">
            E-mail
          </label>
          <TextField
            id="pf-email-input"
            type="email"
            className="w-100"
            placeholder="Escreva aqui"
            value={email}
            onChange={(event) => setEmail(event.target.value)}
            variant="standard"
          />
        </div>

        <div className="d-flex flex-column align-items-center gap-3">
          <button
            type="button"
            className="btn-default-wl"
            style={{ maxWidth: "260px" }}
            onClick={handleSave}
            disabled={isLoading}
          >
            {isLoading ? "SALVANDO..." : "SALVAR E-MAIL"}
          </button>
          <button
            type="button"
            className="btn-outline-wl"
            style={{ maxWidth: "260px" }}
            onClick={onClose}
            disabled={isLoading}
          >
            CANCELAR
          </button>
        </div>
      </Container>
    </ModalApp>
  );
}

EmailModal.propTypes = {
  show: PropTypes.bool.isRequired,
  defaultEmail: PropTypes.string,
  onClose: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
  isLoading: PropTypes.bool,
};
